<button
	uiNewButtonBasic
	(click)="clear()"

	class="text-m text-primary-500 px-1"
>
	{{ 'general.clear' | transloco }}
</button>
